module.exports = __webpack_public_path__ + "static/media/holiday1.a0108be8.webp";